module.exports = __webpack_public_path__ + "static/media/insta-1-min.ba43ad3d.png";